import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

<link rel="stylesheet" href="https://use.typekit.net/eox7oop.css"/>

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);